import filtersCentersAndBosses from './filtersCentersAndBosses'

export default [
  {
    name: 'CourseCategories',
    label: 'Categorias',
    type: 'select',
    collection: 'coursecategories',
    isMulti: true,
  },
  ...filtersCentersAndBosses,
]
